// extracted by mini-css-extract-plugin
module.exports = {"viewFullDetailsButton":"ViewFullDetails_viewFullDetailsButton__5hVAX"};